<template>
  <v-container>
    <h1>Módulos</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          @click="dialogAssignModules = true, getModules()"
          :disabled="!permissionList.includes('assignModules')"
        >
          {{ "Asignar módulo" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="assignedModules" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Módulo" }}</th>
            <th class="header__title center">{{ 'Descripción' }}</th>
            <th class="header__title center">{{ 'Fecha de asignación' }}</th>
            <th class="header__title right">{{ 'Acciones' }}</th> 
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sName  }}</td>
            <td class="table__item">{{ item.sDescription  }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogAssignModules" v-if="dialogAssignModules" max-width="600px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 600px">
          <!-- Título -->
          <v-card-title
            class="pa-0"
            style="display: flex; text-align: center; justify-content: center;"
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Asignación de módulos" }}
            </span>
          </v-card-title>

          <!-- Subtítulo -->
          <v-card-subtitle
            class="mt-2 pb-0"
            style="text-align: center;"
          >
            {{ "Selecciona los módulos que deseas asignar a esta empresa." }}
          </v-card-subtitle>

          <!-- Checkboxes -->
          <v-card-text class="py-6 px-4">

            <v-row>
              <!-- Render dinámico en 2 columnas -->
              <v-col cols="12" sm="6">
                <div v-for="(module, idx) in leftColumn" :key="module.sModuleId">
                  <v-checkbox
                    color="black"
                    hide-details
                    v-model="module.checked"
                    :label="module.sDescription"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div v-for="(module, idx) in rightColumn" :key="module.sModuleId">
                  <v-checkbox
                    color="black"
                    hide-details
                    v-model="module.checked"
                    :label="module.sDescription"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Botones -->
          <v-card-actions class="mt-5" style="justify-content: space-evenly">
            <v-btn
              elevation="4"
              class="mr-2 px-10"
              style="
                color: black;
                border-radius: 36px;
                border: 2px solid black;
                background-color: #fff;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              outlined
              :disabled="loadingModules"
              @click="dialogAssignModules = false"
            >
              {{ "Cancelar" }}
            </v-btn>

            <v-btn
              color="black"
              elevation="4"
              class="white--text px-10"
              @click="assignModules()"
              :disabled="loadingModules"
              style="
                border-radius: 36px;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
            >
              {{ "Asignar módulos" }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Modulos",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        assignedModules: [],
        modules: [],
        dialogAssignModules: false,
        isLoading: false,
        loadingModules: false,
        dialogRequestPayment: false,
        forward: null,
        modulesAvaible: {
          invoicesToPay: false,
          invoicesToCollect: false,
          fwAssignedToInvoicesToPay: false,
          fwAssignedToInvoicesToCollect: false,
          conversionsInvoicesToCollect: false,
          incomeHistory: false,
          conversionsInvoicesToPay: false,
          expensesToCollect: false,
          expensesToPay: false,
          clients: false,
          general: false,
          statement: false,
        },
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'modules') {
          this.getEnterpriseModules();
        }
      }
    },
    computed: {
      modulesWithCheck() {
        const assignedIds = new Set((this.assignedModules || []).map(m => m.sModuleId));

        return (this.modules || []).map(m => ({
          ...m,
          checked: assignedIds.has(m.sModuleId), // true si ya está asignado
        }));
      },
      leftColumn() {
        const mid = Math.ceil(this.modulesWithCheck.length / 2);
        return this.modulesWithCheck.slice(0, mid);
      },
      rightColumn() {
        const mid = Math.ceil(this.modulesWithCheck.length / 2);
        return this.modulesWithCheck.slice(mid);
      },
    },
    mounted() {
      if (this.activeTab === 'modules') {
        this.getEnterpriseModules();
      }
    },
    methods: {
      getEnterpriseModules() {
        this.isLoading = true;
        this.assignedModules = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/enterpriseModules`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.assignedModules = response.data.modules;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      getModules() {
        this.loadingModules = true;
        this.modules = [];

        DB.get(`${URI}/api/v1/en/administrator/modules`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.modules = response.data.modules;
          this.loadingModules = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      assignModules() {
        const selectedModuleIds = this.modulesWithCheck
          .filter(m => m.checked)
          .map(m => m.sModuleId);

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          modules: selectedModuleIds,
        };

        DB.post(`${URI}/api/v1/en/administrator/assignModules`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          console.log(payload)
          this.dialogAssignModules = false;
          this.getEnterpriseModules();
          this.mixSuccess("Módulos asignados correctamente.");
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
    }
  };
</script>
<style scoped>
</style>